import { useOrderFormStore } from "@/stores/forms/orderFormStore";

import useOrderEndpoints from "@/composables/api/useOrderEndpoints";
import useOrderCreation from "@/composables/api/useOrderCreation";
import useMerchApiEndpoints from "@/composables/api/useMerchApiEndpoints";

export default () => {
  const orderStore = useOrderFormStore();
  const { initOrder } = useOrderEndpoints();
  const { defaultData, disableUiByApi } = useOrderCreation();
  const { getApiOrder, getPAPIOrder } = useMerchApiEndpoints();

  const forceStringType = (value) => {
    return value && typeof value === "string" ? value : String(value);
  };

  const isAnApiOrder = (() => {
    const params = new URLSearchParams(window.location.search);
    return params.has("id") || params.has("initId");
  })();

  const isAnPapiOrder = (() => {
    const params = new URLSearchParams(window.location.search);
    return params.has("initId");
  })();
 
  const checkApiForOrderTypeAndSetMode = async () => {
    const checkOrderTypeAndSetMode = (data) => {
      if (
        !Object.getOwnPropertyDescriptor(data, 'orderType') &&
        data.orderType !== "CRYPTO-BUY" &&
        data.orderType !== "CRYPTO-SELL"
      ) {
        console.error("No order type in api data: ", data);
        return;
      }

      const orderType = data.orderType.toUpperCase().replace("CRYPTO-", "");

      defaultData.orderMode = orderType;
      orderStore.setActiveMode(orderType);
    };

    if (!isAnApiOrder) {
      return defaultData;
    }

    const clearOrder = await initOrder();

    if (isAnPapiOrder) {
      const getMerchOrder = await getPAPIOrder();
      return Promise.all([clearOrder, getMerchOrder]).then(
        ([clearOrderRes, merchOrderRes]) => {
          if (!merchOrderRes) {
            return defaultData;
          }
  
          checkOrderTypeAndSetMode(merchOrderRes.data);
          orderStore.setMerchApiData(merchOrderRes.data);
          defaultData.urlData = merchOrderRes.data;
          defaultData.disableUIKeys = disableUiByApi(merchOrderRes.data);
          defaultData.areDefaultsFromUrl = true;

          const params = new URLSearchParams(window.location.search);
          if (params.has("subscriptionId")){
            defaultData.urlData = {
              ...defaultData.urlData,
              subscriptionId: params.get("subscriptionId"),
            }
          }
          return defaultData;
        }
      );
    }

    const getMerchOrder = await getApiOrder();

    return Promise.all([clearOrder, getMerchOrder]).then(
      ([clearOrderRes, merchOrderRes]) => {
        if (!merchOrderRes) {
          return defaultData;
        }

        if (merchOrderRes.data?.walletAddressTag) {
          merchOrderRes.data.walletAddressTag = forceStringType(
            merchOrderRes.data.walletAddressTag
          );
        }
        checkOrderTypeAndSetMode(merchOrderRes.data);
        orderStore.setMerchApiData(merchOrderRes.data);
        defaultData.urlData = merchOrderRes.data;
        defaultData.disableUIKeys = disableUiByApi(merchOrderRes.data);
        defaultData.areDefaultsFromUrl = true;

        if (merchOrderRes.data?.walletAddressTag) {
          orderStore.getActiveStore.setRequiredFieldByKey(
            "walletAddressTag",
            true
          );
        }

        return defaultData;
      }
    );
  };

  const checkApiForNFTOrder = async () => {
    if (!isAnApiOrder) {
      return defaultData;
    }

    const clearOrder = await initOrder();
    const merchOrderRes = await getApiOrder();
    if (!merchOrderRes) {
      return defaultData;
    }
    if (merchOrderRes.data?.walletAddressTag) {
      merchOrderRes.data.walletAddressTag = forceStringType(
        merchOrderRes.data.walletAddressTag
      );
    }
    orderStore.setMerchApiData(merchOrderRes.data);
    defaultData.urlData = merchOrderRes.data;
    defaultData.areDefaultsFromUrl = true;
    defaultData.orderMode = "NFT-BUY";
    defaultData.disableUIKeys = {
      fiatAmount: true,
      fiatType: !!merchOrderRes.data.lockFiat,
      ...disableUiByApi(merchOrderRes.data),
    };
    return defaultData;
  };

  return {
    isAnApiOrder,
    checkApiForOrderTypeAndSetMode,
    checkApiForNFTOrder,
  };
};
